export const DEFAULT_PHOTOGALLERY_IMAGE_RATIO = "4x3";
